import axios from "axios";

let baseUrl = "https://telfers.dev.simplesoftware.nz/";
let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082" ||
  host == "192.168.178.21:8080" ||
  host == "192.168.178.21:8081" ||
  host == "192.168.178.21:8082" ||
  host == "10.0.0.9:8080"
) {
  // baseUrl = "http://localhost:9080/";
  baseUrl = "https://telfers.dev.simplesoftware.nz/";
} else if (host == "https://telfersadmin.firebaseapp.com/") {
  baseUrl = "https://telfers.dev.simplesoftware.nz/";
} else if (host.substring(0, 4) == "dev.") {
  baseUrl = "https://telfers.dev.simplesoftware.nz/";
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

export default api;
